// extracted by mini-css-extract-plugin
export default {"container":"maincon_container__BQQty"};